<script>
    import R, {LOADER} from "../lib/js/requests";
    import department$ from "../lib/stores/department$.js";
    import {PAYMENT_TYPE, ROUTE_TYPE} from "../lib/js/constants.js";
    import {copyObject, fnt} from "../lib/js/utils.js";
    import PhoneControl from "../lib/controls/PhoneControl.svelte";
    import Icon from "../lib/components/icons/Icon.svelte";
    import ReservationSummary from "./ReservationSummary.svelte";
    import BankPolicy from "../lib/components/BankPolicy.svelte";

    export let reservation;
    export let onBack = fnt();

    let reservation_price = Number(reservation.price);
    let hotel = null;
    let nameLabel = "Name";
    let phoneLabel = "Phone";
    let emailLabel = "Email";

    const initialize = () => {
        if ($department$.payment_method == PAYMENT_TYPE.BANK) {
            reservation.payment_type = PAYMENT_TYPE.BANK;
            nameLabel = "Guest Name";
            phoneLabel = "Guest Phone";
            emailLabel = "Guest Email";
        } else {
            reservation.payment_type = reservation_price > 0 ? PAYMENT_TYPE.CARD : PAYMENT_TYPE.CASH;
        }
        reservation.routes.map(route => {
            if (!hotel && route._pickup.hotel_id > 0) {
                hotel = route._pickup;
            }
            if (!hotel && route._drop.hotel_id > 0) {
                hotel = route._drop;
            }
        });
    }

    const submit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const onSuccess = result => {
            if (result.redirect_to) {
                window.location.href = result.redirect_to;
            }
        }

        const onFailure = err => {
        };

        let data = copyObject(reservation);

        if (!hotel) {
            data.room_no = '';
        }

        data.routes.map(route => {
            if (route.route_type == ROUTE_TYPE.TRANSFER) {
                route.flight_no = '';
            }
        });

        if (data.children == 0) {
            data.baby_seats = 0;
            data.boosters = 0;
        }
        if (data.infants == 0) {
            data.infant_seats = 0;
        }

        R.handle(R.reservation.create, data, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();
</script>

<form on:submit={submit}>
    <div class="row">
        <div class="col-md-5 mb-5">
            <ReservationSummary {reservation}/>
        </div>
        <div class="col-md-7 mb-5">
            <div class="section-title mb-4">
                <h2 class="h4 mb-0">Personal Info</h2>
            </div>
            {#if reservation.payment_type == PAYMENT_TYPE.BANK}
                <div class="mb-4">
                    <label>Agent Email</label>
                    <input type="text" class="form-control" bind:value={reservation.agent_email}
                           placeholder="agent email"
                           required>
                </div>
            {/if}
            <div class="mb-4">
                <label>{nameLabel}</label>
                <input type="text" class="form-control" bind:value={reservation.fullname} placeholder="full name"
                       required>
            </div>
            <div class="row">
                <div class="col-md-6 mb-4">
                    <label>{phoneLabel}</label>
                    <PhoneControl bind:value={reservation.phone} required/>
                </div>
                <div class="col-md-6 mb-4">
                    <label>{emailLabel}</label>
                    <input type="email" class="form-control" bind:value={reservation.email} placeholder="email"
                           required>
                </div>
                {#if hotel}
                    <div class="col-md-6 mb-4">
                        <label>{hotel.name} room number (if applicable)</label>
                        <input type="text" class="form-control" style="max-width:160px;"
                               bind:value={reservation.room_no}>
                    </div>
                {/if}
            </div>
            <div class="mb-4">
                <label>Notes</label>
                <textarea class="form-control" bind:value={reservation.notes}></textarea>
            </div>

            {#if reservation.payment_type == PAYMENT_TYPE.BANK}
                <BankPolicy checkout/>
            {/if}

            <div class="form-check mb-4">
                <input class="form-check-input" type="checkbox" value="" id="checkTerms" required>
                <label class="form-check-label" for="checkTerms">
                    I have read and agree with the <a href="/{$department$.link_code}/terms" target="_blank">Terms and
                    cancellation policy</a>.
                </label>
            </div>

            {#if reservation.payment_type == PAYMENT_TYPE.CARD}
                <p class="mb-0">
                    Payment is made through
                    <span class="viva-logo"><img src="/app/assets/images/viva-wallet.svg" class="img-fluid"
                                                 alt="viva wallet"/></span>
                    Viva Wallet.<br>
                    You will be transferred to the Viva Wallet platform to complete your payment.
                </p>
            {/if}

        </div>
    </div>

    <div class="row">
        <div class="col-lg-3 col-md-3 col-5">
            <button type="button"
                    class="btn btn-secondary d-flex align-items-center justify-content-center gap-1 w-100 px-0 py-3"
                    on:click={onBack}>
                <span class="btn-icon"><Icon name="chevron-left" size="16"/></span>
                Back
            </button>
        </div>
        <div class="col-lg-6 col-md-5 hidden-sm hidden-xs"></div>
        <div class="col-lg-3 col-md-4 col-7">
            {#if reservation.payment_type == PAYMENT_TYPE.CARD}
                <button class="btn btn-primary fw-semibold d-flex align-items-center justify-content-center gap-1 gap-1 w-100 px-0 py-3">
                    <span class="hidden-xs">
                        Proceed to Payment
                    </span>
                    <span class="hidden-sm hidden-md hidden-lg hidden-xl">
                        Payment
                    </span>
                </button>
            {:else}
                <button type="submit"
                        class="btn btn-primary fw-semibold d-flex align-items-center justify-content-center gap-1 w-100 px-0 py-3">
                    <span class="btn-icon"><Icon name="check" size="16"/></span>
                    Finish
                </button>
            {/if}
        </div>
    </div>
</form>

<style>
    .viva-logo {
        width: 25px;
        display: inline-block;
        background: #f7f7f7;
        border-radius: 3px;
        padding: 0 2px;
    }
</style>